import { FluidIconConfig, FluidSize, FluidTheme } from '@lmig/fluid-core';
import { h } from '@stencil/core';

import { TranslatableSlot } from '../../../common/fluid-component-rendering.components';
import { FluidI18nStore } from '../../../providers/fluid-i18n-provider/store/fluid-i18n.store';
import { themeVar } from '../../../utils/themes/theme.variables';

/**
 * @TODO - Move to core (Upcoming PR with documentation to move all translation options to Core)
 */
export interface FluidLinkTranslationOptions {
  content?: string;
}

interface LinkIconProps {
  position: 'before' | 'after';
  theme?: FluidTheme;
  iconConfig?: FluidIconConfig;
  disabled?: boolean;
  identifier: string;
}
export const LinkIcon = (props: LinkIconProps) => {
  const {
    position,
    theme = FluidTheme.CORP,
    iconConfig,
    disabled,
    identifier,
  } = props;
  const defaultSize = themeVar<FluidSize>(theme, 'icons.default_size');

  return (
    !!iconConfig && (
      <fluid-icon
        config={{
          ...iconConfig,
          size: iconConfig.size ?? defaultSize,
          theme: theme,
          overrideGlobalTheme: true,
        }}
        class={{
          'link-icon': true,
          [`icon-${position}`]: true,
          disabled: disabled,
        }}
        data-test-id={`${identifier}-link-icon-${position}`}
      />
    )
  );
};

interface LinkTextProps {
  store?: FluidI18nStore;
  fluidTranslate?: FluidLinkTranslationOptions;
  identifier: string;
}
export const LinkText = (props: LinkTextProps) => {
  const { store, fluidTranslate, identifier } = props;
  return (
    <span class='link-content' data-test-id={`${identifier}-link-content`}>
      <TranslatableSlot
        store={store}
        translationKey={fluidTranslate?.content}
      />
    </span>
  );
};
